<template>
  <header
    ref="header"
    class="sticky top-0 z-50 flex items-center justify-between bg-surface-level-1 p-4 text-neutral-emphasis shadow-default">
    <div class="flex shrink-0 items-center gap-x-4">
      <div
        :class="{
          'md:hidden': numberOfNavigationItems === 1,
          'menu-premium:hidden': numberOfNavigationItems > 1,
          hidden: numberOfNavigationItems === 0,
        }">
        <AppMenuMobile />
      </div>
      <RouterLink :to="{ name: 'root' }" class="shrink-0" data-testid="appLogo">
        <img ref="logo" :src="DpaNewsLogo" class="w-34.75" />
      </RouterLink>
    </div>
    <div
      ref="desktopMenu"
      data-testid="desktopMenu"
      :class="{
        'hidden md:block': numberOfNavigationItems === 1,
        'hidden menu-premium:block': numberOfNavigationItems > 1,
        hidden: numberOfNavigationItems === 0,
      }"
      class="mr-3 ml-6 flex-1 md:ml-12">
      <AppMenuDesktop />
    </div>
    <HeaderIdComponents ref="idComps" />
  </header>
</template>

<script lang="ts" setup>
import DpaNewsLogo from "@/assets/vectors/dpa-news-logo.svg?url";
import useNavigation from "@/composition/shared/useNavigation.ts";

import AppMenuDesktop from "../AppMenu/AppMenuDesktop.vue";
import AppMenuMobile from "../AppMenu/AppMenuMobile.vue";

import HeaderIdComponents from "./HeaderIdComponents.vue";

const { numberOfNavigationItems } = useNavigation();
</script>
